import AwardBadge from "@/components/AwardBadge";

export default function AwardContext() {
  return (
    <section className="py-14 bg-cvc-parchment/60 border-y border-cvc-border">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 text-center">
        <AwardBadge size="md" align="center" className="mx-auto" />
        <p className="font-heading text-2xl md:text-3xl text-cvc-navy mt-6 leading-snug italic">
          "Epic Enterprises Consulting has served Cache Valley since 2018, working directly with local owners through its
          Cache Valley Consulting division to strengthen teams, structure operations, and steady growth."
        </p>
        <p className="font-body text-sm text-cvc-ink-soft mt-5">
          We're deeply honored to receive this award — and even more grateful for every Cache Valley owner who has
          trusted us to help write the next chapter of their business.
        </p>
      </div>
    </section>
  );
}
